import { render, staticRenderFns } from "./ScholarshipCard.vue?vue&type=template&id=dbeaf10c&scoped=true&"
import script from "./ScholarshipCard.vue?vue&type=script&lang=js&"
export * from "./ScholarshipCard.vue?vue&type=script&lang=js&"
import style0 from "./ScholarshipCard.vue?vue&type=style&index=0&id=dbeaf10c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbeaf10c",
  null
  
)

export default component.exports